import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isFormFilter'
})
export class IsFormFilterPipe implements PipeTransform {

  transform(tests: any[], isForm: boolean): any[] {
    let response = [];
    tests.map(
      test => {
        if (test.type == 'FORMULARIO' && isForm){
          response.push(test);
        }
        if (test.type != 'FORMULARIO' && !isForm){
          response.push(test);
        }
      }
    )
    return response;
  }

}
